module.exports = __webpack_public_path__ + "img/couches.591888b5.png";